import { DueBadge } from '@/entities/shared/due/due-badge';
import { taskDueOf } from '../helpers/task-due-of';
import type { Task } from '../schemas/task';

type TaskDueProps = {
  readonly task: Task;
};

/** When the task is due, or from when it can start; coloured only when it is time or late. */
export function TaskDue({ task }: TaskDueProps) {
  return <DueBadge due={taskDueOf(task)} />;
}
